import React from 'react'
import Input from 'base/react/components/form/input'
import FlatButton from 'base/react/components/flat_button'
import EyeActive from 'base/components/ui/eye-active'
import EyeInactive from 'base/components/ui/eye-inactive'

function PasswordResetPasswordForm({
  password,
  onChange,
  onSubmit,
  error,
  passwordRevealed,
  onTogglePassword,
}) {
  return (
    <form
      onSubmit={event => {
        event.preventDefault()
        onSubmit()
      }}
      style={{ position: 'relative' }}
    >
      <div className="password-reset__password-wrapper">
        <Input
          required
          autofocus
          inputCLass="password-reset__input"
          label="New Password"
          labelClass="password-reset__label"
          inputClass="password-reset__input"
          error={error}
          errorClass="password-reset__input--error"
          type={passwordRevealed ? 'text' : 'password'}
          name="passwordInput"
          value={password || ''}
          onChange={onChange}
        />
        <div onClick={onTogglePassword} className="password-reset__password-reveal">
          {passwordRevealed ? <EyeActive /> : <EyeInactive />}
        </div>
      </div>
      <FlatButton
        color="dark-grey"
        onClick={onSubmit}
        className="password-reset__button"
        disabled={!password}
      >
        Set Password
      </FlatButton>
    </form>
  )
}

export default PasswordResetPasswordForm
